export const EQUIPMENT_TABS = ['status', 'diagnostics', 'performance'] as const;

export const ThresholdColors = {
  Red: '#E6352B',
  Yellow: '#F79009',
  Green: '#039855',
  Blue: '#2970FF',
} as const;
